import dayjs from 'dayjs';
export const getLineOption = (list, t)=>{
    /** 日期不要年取月日即可 */ const formatList = (list === null || list === void 0 ? void 0 : list.map((item)=>({
            ...item,
            name: t(`c_a_issue_${item.name}`)
        }))) ?? [];
    return {
        tooltip: {
            trigger: 'axis',
            formatter: (params)=>{
                var _params_;
                let text = '';
                const name = (_params_ = params[0]) === null || _params_ === void 0 ? void 0 : _params_.name;
                text += `${name}<br/>`;
                params.forEach((param)=>{
                    if (param.seriesIndex === 0) {
                        text += `${param.seriesName}：${param.value}<br/>`;
                    } else if (param.seriesIndex === 1) {
                        text += `${param.seriesName}：${param.value}%<br/>`;
                    }
                });
                return text;
            }
        },
        grid: {
            left: 10,
            right: 10,
            bottom: 10,
            containLabel: true
        },
        xAxis: {
            type: 'category',
            data: formatList === null || formatList === void 0 ? void 0 : formatList.map((item)=>item.name),
            axisLabel: {
                interval: 0,
                rotate: (formatList === null || formatList === void 0 ? void 0 : formatList.length) > 10 ? 40 : 0,
                formatter: function(value) {
                    const limit = 8 // 被截断的最大字符数
                    ;
                    return value.length > limit ? (value === null || value === void 0 ? void 0 : value.slice(0, limit)) + '...' : value;
                }
            }
        },
        yAxis: [
            /** Y轴左侧呼入数量 */ {
                type: 'value',
                // name: t('c_d_phone_data_incoming_call_num'),
                min: 0,
                position: 'left',
                axisLabel: {
                    show: true,
                    formatter: '{value}'
                },
                splitLine: {
                    show: true
                }
            },
            /** Y轴右侧呼出数量 */ {
                type: 'value',
                // name: t('c_d_phone_data_exhalation_num'),
                min: 0,
                max: 100,
                position: 'right',
                axisLabel: {
                    show: true,
                    formatter: (value)=>`${value}%` // 格式化为百分比
                },
                splitLine: {
                    show: false
                }
            }
        ],
        series: [
            /** 独立解决通话数量 */ {
                name: t('c_a_resolve_number'),
                type: 'bar',
                data: formatList === null || formatList === void 0 ? void 0 : formatList.map((item)=>item.no_repeat_count),
                yAxisIndex: 0,
                tooltip: {
                    valueFormatter: function(value) {
                        return value;
                    }
                },
                itemStyle: {
                    normal: {
                        color: '#ffb72b',
                        barBorderRadius: [
                            10,
                            10,
                            0,
                            0
                        ]
                    }
                },
                barWidth: (formatList === null || formatList === void 0 ? void 0 : formatList.length) < 12 ? 36 : 'auto',
                label: {
                    show: true,
                    position: 'top',
                    formatter: (params)=>params.value
                }
            },
            /** 独立解决通话数量占比 */ {
                name: t('c_a_resolve_rate'),
                type: 'bar',
                data: formatList === null || formatList === void 0 ? void 0 : formatList.map((item)=>item.no_repeat_rate),
                yAxisIndex: 1,
                tooltip: {
                    valueFormatter: function(value) {
                        return value;
                    }
                },
                itemStyle: {
                    normal: {
                        color: '#63D15C',
                        barBorderRadius: [
                            10,
                            10,
                            0,
                            0
                        ]
                    }
                },
                barWidth: (formatList === null || formatList === void 0 ? void 0 : formatList.length) < 12 ? 36 : 'auto',
                label: {
                    show: true,
                    position: 'top',
                    formatter: (params)=>{
                        return `${params.value}%`;
                    }
                }
            }
        ]
    };
};
export const getStackBarOption = (list, t)=>{
    const formatList = (list === null || list === void 0 ? void 0 : list.map((item)=>({
            ...item,
            new_date: dayjs(item.create_date).format('MM.DD'),
            /** 计算百分比 */ resolveRate: Number(((item.ai_solved_first ?? 0) + (item.ai_solved_twice ?? 0) + (item.ai_solved_three ?? 0) + (item.ai_solved_more_than_three ?? 0)) / item.to_ai * 100).toFixed(2)
        }))) ?? [];
    const safePercent = (v)=>isNaN(v) || v === null ? 0 : v;
    return {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            },
            formatter: (params)=>{
                const paramList = Array.isArray(params) ? params : [
                    params
                ];
                const newDate = paramList[0].name;
                /**  根据日期找到原始对象 */ const dataItem = formatList.find((i)=>i.new_date === newDate);
                const fullDate = (dataItem === null || dataItem === void 0 ? void 0 : dataItem.create_date) ?? newDate;
                let resolveRate = 0;
                if (dataItem === null || dataItem === void 0 ? void 0 : dataItem.to_ai) {
                    const sum = [
                        dataItem.ai_solved_first,
                        dataItem.ai_solved_twice,
                        dataItem.ai_solved_three,
                        dataItem.ai_solved_more_than_three
                    ].reduce((acc, val)=>acc + (val ?? 0), 0);
                    resolveRate = Number((sum / dataItem.to_ai * 100).toFixed(2));
                }
                let text = `<div style="font-weight:bold; font-size:14px; margin-bottom:4px;">${fullDate}</div>
                            <div style="font-size:13px; margin-bottom:6px;">${t('c_a_resolve_resolution_rate')}： <span style="font-weight:bold">${resolveRate}%</span></div>`;
                paramList.forEach((item)=>{
                    text += `<div style="display:flex; align-items:center; margin-bottom:4px;">
                    <span style="display:inline-block;width:8px;height:8px;margin-right:6px;
                        border-radius:50%; background-color:${item.color}"></span>
                    <span style="font-size:13px">${item.seriesName}： ${safePercent(item.value)}%</span></div>`;
                });
                return text;
            }
        },
        grid: {
            left: 10,
            right: 10,
            bottom: 50,
            top: 26,
            containLabel: true
        },
        legend: {
            data: [
                {
                    name: t('c_a_resolve_one_reception'),
                    itemStyle: {
                        color: '#63D15C'
                    }
                },
                {
                    name: t('c_a_resolve_two_reception'),
                    itemStyle: {
                        color: '#FFB72B'
                    }
                },
                {
                    name: t('c_a_resolve_therr_reception'),
                    itemStyle: {
                        color: '#9B5DE5'
                    }
                },
                {
                    name: t('c_a_resolve_more_reception'),
                    itemStyle: {
                        color: '#FF8C42'
                    }
                }
            ],
            bottom: 14,
            left: 'center',
            type: 'scroll'
        },
        xAxis: {
            type: 'category',
            data: formatList.map((i)=>i.new_date)
        },
        yAxis: {
            type: 'value',
            min: 0,
            max: 100,
            axisLabel: {
                formatter: '{value}%'
            }
        },
        series: [
            {
                name: t('c_a_resolve_one_reception'),
                type: 'bar',
                stack: 'resolve',
                barWidth: (formatList === null || formatList === void 0 ? void 0 : formatList.length) < 15 ? 40 : 'auto',
                data: formatList.map((i)=>({
                        value: Number(((i.ai_solved_first ?? 0) / i.to_ai * 100).toFixed(2)),
                        itemStyle: {
                            color: '#63D15C'
                        }
                    }))
            },
            {
                name: t('c_a_resolve_two_reception'),
                type: 'bar',
                stack: 'resolve',
                barWidth: (formatList === null || formatList === void 0 ? void 0 : formatList.length) < 15 ? 40 : 'auto',
                data: formatList.map((i)=>({
                        value: Number(((i.ai_solved_twice ?? 0) / i.to_ai * 100).toFixed(2)),
                        itemStyle: {
                            color: '#FFB72B'
                        }
                    }))
            },
            {
                name: t('c_a_resolve_therr_reception'),
                type: 'bar',
                stack: 'resolve',
                barWidth: (formatList === null || formatList === void 0 ? void 0 : formatList.length) < 15 ? 40 : 'auto',
                data: formatList.map((i)=>({
                        value: Number(((i.ai_solved_three ?? 0) / i.to_ai * 100).toFixed(2)),
                        itemStyle: {
                            color: '#9B5DE5'
                        }
                    }))
            },
            {
                name: t('c_a_resolve_more_reception'),
                type: 'bar',
                stack: 'resolve',
                barWidth: (formatList === null || formatList === void 0 ? void 0 : formatList.length) < 15 ? 40 : 'auto',
                data: formatList.map((i)=>({
                        value: Number(((i.ai_solved_more_than_three ?? 0) / i.to_ai * 100).toFixed(2)),
                        itemStyle: {
                            color: '#FF8C42',
                            borderRadius: [
                                8,
                                8,
                                0,
                                0
                            ]
                        }
                    }))
            }
        ]
    };
};
